var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "emailInputBox"
  }, [_c('div', {
    staticClass: "tagBox"
  }, [_c('span', _vm._l(_vm.emailList, function (item, index) {
    return _c('span', {
      key: index,
      staticClass: "tagInfo"
    }, [_c('span', {
      staticClass: "tagText"
    }, [_vm._v(" " + _vm._s(item) + " ")]), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function ($event) {
          return _vm.deleteEmail(item);
        }
      }
    })]);
  }), 0)]), _c('div', {
    staticClass: "inputBox"
  }, [_c('input', {
    ref: "input",
    staticClass: "emailInput",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return (event => _vm.addEmail(event, 'enter')).apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.preventDefault();
        return (event => _vm.addEmail(event, 'space')).apply(null, arguments);
      }],
      "input": _vm.checkEmail,
      "blur": event => _vm.addEmail(event, 'blur')
    }
  })])]), _c('p', {
    staticClass: "errorMsg redColor",
    class: {
      active: _vm.showErrorMsg
    }
  }, [_vm._v(_vm._s(_vm.$t('aiSpeech.errorEmail')))])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };